import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { closeToast } from '../store/alertSlice';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars() {
    const dispatch = useDispatch()
    let open = useSelector((state) => state.alertReducer.openAlert);
    let message = useSelector((state) => state.alertReducer.openMessage);
    let error = useSelector((state) => state.alertReducer.openStatus);
    const handleClose = ()=>{
       dispatch(closeToast())
    }
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar  anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }} open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={error} sx={{ width: '100%' }}>
        {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}